import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ExternalLink } from "lucide-react";
import api from "../api";

// Banner compatto (chiudibile) mostrato all'admin quando la completezza dati ESG core
// è sotto la soglia configurata. Usa la sessione per non ripresentarsi dopo la chiusura.
export const EsgReadinessBanner = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("esg_banner_dismissed") === "1");

  useEffect(() => {
    api.get("/esg/readiness").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (dismissed || !data || !data.below_threshold) return null;
  const overall = data.overall_completeness || 0;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 flex items-start gap-3" data-testid="esg-readiness-banner">
      <AlertTriangle size={20} className="text-amber-600 mt-0.5 shrink-0" />
      <div className="flex-1">
        <div className="text-[14px] font-bold text-amber-800">Completezza dati ESG al {overall}% (soglia {data.threshold}%)</div>
        <div className="text-[13px] text-gray-700 mt-0.5">
          Alcuni dati Social richiesti dall'ESG non sono completi. Completa l'anagrafica e i moduli per raggiungere la soglia.
          <Link to="/esg" data-testid="esg-banner-link" className="ml-1 inline-flex items-center gap-1 font-bold text-[#0d6cb8] hover:text-[#0a5590]"><ExternalLink size={13} /> Vai a ESG / Sostenibilità</Link>
        </div>
      </div>
      <button
        onClick={() => { setDismissed(true); sessionStorage.setItem("esg_banner_dismissed", "1"); }}
        data-testid="esg-banner-dismiss"
        className="text-gray-400 hover:text-gray-600 text-[12px] font-bold shrink-0">Nascondi</button>
    </div>
  );
};
